import { GlobalAxios } from "./../axios/axios-config";
import {
  INewScheduleNewCheckIn,
  IScheduleNewCheckIn,
} from "../models/schedule-new-check-in";

const SCHEDULE_NEW_CHECKIN_ROUTE =
  process.env.REACT_APP_CALENDAR + "/api/v1/TasySchedNewCheckInRule";

export const createScheduleNewCheckIn = (item: INewScheduleNewCheckIn) => {
  return GlobalAxios.post(SCHEDULE_NEW_CHECKIN_ROUTE, item);
};

export const getScheduleNewCheckInById = (id: string) => {
  return GlobalAxios.get<IScheduleNewCheckIn>(
    SCHEDULE_NEW_CHECKIN_ROUTE + "/" + id
  );
};

export const updateScheduleNewCheckInById = ({
  item,
  id,
}: {
  item: INewScheduleNewCheckIn;
  id: string;
}) => {
  return GlobalAxios.put(SCHEDULE_NEW_CHECKIN_ROUTE + "/" + id, item);
};
